/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Aibody1Inputs */

const zh_landing_admin_aibody1 = /** @type {(inputs: Landing_Admin_Aibody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随时为学生提供即时帮助。StudyOS 通过对话式 AI 辅导给出清晰的讲解和分步解答，特别适合课后巩固、答疑和自主学习。`)
};

const en_landing_admin_aibody1 = /** @type {(inputs: Landing_Admin_Aibody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give students instant support, anytime. StudyOS provides clear explanations and step-by-step solutions through a chat-style AI tutor. Perfect for reinforcing lessons, answering questions, and supporting independent learning outside the classroom.`)
};

const es_landing_admin_aibody1 = /** @type {(inputs: Landing_Admin_Aibody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofrece apoyo inmediato al alumnado en cualquier momento. StudyOS ofrece explicaciones claras y soluciones paso a paso mediante un tutor IA conversacional. Ideal para reforzar lecciones, resolver dudas y apoyar el aprendizaje autónomo fuera del aula.`)
};

/**
* | output |
* | --- |
* | "Give students instant support, anytime. StudyOS provides clear explanations and step-by-step solutions through a chat-style AI tutor. Perfect for reinforcing..." |
*
* @param {Landing_Admin_Aibody1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_aibody1 = /** @type {((inputs?: Landing_Admin_Aibody1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Aibody1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_aibody1(inputs)
	if (locale === "en") return en_landing_admin_aibody1(inputs)
	return es_landing_admin_aibody1(inputs)
});
export { landing_admin_aibody1 as "landing_admin_aiBody" }